// ============================================
// label-web/src/pages/Broadcast.js (Admin — Saskara Record)
// Tambahkan route di App.js: <Route path="/broadcast" element={<Broadcast />} />
// Tambahkan menu di Layout.js sidebar: "Broadcast Email"
// ============================================
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://admin.saskararecord.com/api';

export default function Broadcast() {
  const [segment, setSegment] = useState('all');
  const [subject, setSubject] = useState('');
  const [bodyHtml, setBodyHtml] = useState('');
  const [sending, setSending] = useState(false);
  const [history, setHistory] = useState([]);
  const [message, setMessage] = useState('');
  const [uploadingImage, setUploadingImage] = useState(false);
  const textareaRef = useRef(null);

  const TEMPLATES = [
    {
      id: 'promo_diskon',
      label: 'Promo Diskon Merchandise',
      subject: 'Diskon Spesial Merchandise Minggu Ini!',
      body: `Halo {{name}},

Ada kabar gembira! Merchandise favorit kamu lagi diskon spesial minggu ini.

Jangan sampai kehabisan, cek koleksi lengkapnya sekarang di saskararecord.com/store

Salam hangat,
Tim Saskara Record`,
    },
    {
      id: 'lagu_baru',
      label: 'Pengumuman Lagu Baru',
      subject: 'Rilisan Baru Sudah Bisa Didengarkan!',
      body: `Halo {{name}},

Kabar gembira buat kamu penikmat musik! Ada rilisan baru dari salah satu artis Saskara Record yang siap menemani harimu.

Dengarkan sekarang di saskararecord.com

Salam hangat,
Tim Saskara Record`,
    },
    {
      id: 'event',
      label: 'Pengumuman Event / Konser',
      subject: 'Jangan Lewatkan Event Terbaru Kami!',
      body: `Halo {{name}},

Kami punya event seru yang sayang untuk dilewatkan! Catat tanggalnya dan siapkan dirimu.

Info lengkap dan lokasi bisa dicek di saskararecord.com/events

Sampai jumpa di sana,
Tim Saskara Record`,
    },
    {
      id: 'newsletter',
      label: 'Newsletter / Update Umum',
      subject: 'Update Terbaru dari Saskara Record',
      body: `Halo {{name}},

Ada beberapa kabar terbaru yang ingin kami bagikan ke kamu minggu ini.

Kunjungi saskararecord.com untuk info selengkapnya.

Terima kasih sudah menjadi bagian dari komunitas kami,
Tim Saskara Record`,
    },
    {
      id: 'kosong',
      label: '— Mulai dari Kosong —',
      subject: '',
      body: '',
    },
  ];

  const applyTemplate = (templateId) => {
    const tpl = TEMPLATES.find((t) => t.id === templateId);
    if (!tpl) return;
    setSubject(tpl.subject);
    setBodyHtml(tpl.body);
  };


  const token = localStorage.getItem('admin_token');

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {
      const res = await axios.get(`${API_BASE}/admin/broadcast`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setHistory(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploadingImage(true);
    try {
      const formData = new FormData();
      formData.append('photo', file);
      const res = await axios.post(`${API_BASE}/admin-upload/image`, formData, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
      });
      const imgTag = `<img src="${res.data.url}" alt="" style="max-width:100%;" />`;
      const textarea = textareaRef.current;
      if (textarea) {
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const newValue = bodyHtml.slice(0, start) + imgTag + bodyHtml.slice(end);
        setBodyHtml(newValue);
        setTimeout(() => {
          textarea.focus();
          textarea.selectionStart = textarea.selectionEnd = start + imgTag.length;
        }, 0);
      } else {
        setBodyHtml((b) => b + imgTag);
      }
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal upload gambar');
    } finally {
      setUploadingImage(false);
      e.target.value = '';
    }
  };

  const handleSend = async () => {
    if (!subject || !bodyHtml) {
      setMessage('Subject dan isi email wajib diisi.');
      return;
    }
    if (!window.confirm(`Kirim email ke segment "${segment}"? Aksi ini tidak bisa dibatalkan.`)) return;

    setSending(true);
    setMessage('');
    try {
      const res = await axios.post(
        `${API_BASE}/admin/broadcast`,
        { segment, subject, body_html: bodyHtml },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessage(`Broadcast dikirim (job #${res.data.jobId}), sedang diproses di background.`);
      setSubject('');
      setBodyHtml('');
      fetchHistory();
    } catch (err) {
      setMessage(`Gagal: ${err.response?.data?.error || err.message}`);
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{ padding: 24, color: '#B5B5BC' }}>
      <h2 style={{ color: '#C9A66B' }}>Broadcast Email</h2>

      <div style={{ background: '#1D1D20', padding: 20, borderRadius: 8, marginBottom: 24 }}>
        <label>Gunakan Template:</label>
        <select
          onChange={(e) => applyTemplate(e.target.value)}
          defaultValue=""
          style={{ display: 'block', margin: '8px 0 16px', padding: 8, width: '100%', background: '#2A2A2E', color: '#B5B5BC', border: '1px solid #48484E' }}
        >
          <option value="" disabled>-- Pilih template (opsional) --</option>
          {TEMPLATES.map((t) => (
            <option key={t.id} value={t.id}>{t.label}</option>
          ))}
        </select>
        <label>Kirim ke:</label>
        <select
          value={segment}
          onChange={(e) => setSegment(e.target.value)}
          style={{ display: 'block', margin: '8px 0 16px', padding: 8, width: '100%', background: '#2A2A2E', color: '#B5B5BC', border: '1px solid #48484E' }}
        >
          <option value="guest">Guest / Fans</option>
          <option value="artist">Artis</option>
          <option value="all">Semua</option>
        </select>

        <label>Subject:</label>
        <input
          type="text"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          placeholder="Contoh: Promo Merch Diskon 20% Minggu Ini!"
          style={{ display: 'block', margin: '8px 0 16px', padding: 8, width: '100%', background: '#2A2A2E', color: '#B5B5BC', border: '1px solid #48484E' }}
        />

        <label>Isi Email (HTML diperbolehkan):</label>
        <textarea
          ref={textareaRef}
          value={bodyHtml}
          onChange={(e) => setBodyHtml(e.target.value)}
          rows={8}
          placeholder="Gunakan {{name}} untuk personalisasi nama penerima."
          style={{ display: 'block', margin: '8px 0 8px', padding: 8, width: '100%', background: '#2A2A2E', color: '#B5B5BC', border: '1px solid #48484E' }}
        />
        <label style={{ display: 'inline-block', fontSize: 13, color: '#C9A66B', border: '1px solid #C9A66B', padding: '6px 14px', borderRadius: 6, cursor: 'pointer', marginBottom: 16 }}>
          {uploadingImage ? 'Mengupload...' : '📁 Sisipkan Gambar ke Isi Email'}
          <input type="file" accept="image/jpeg,image/png,image/webp" onChange={handleImageUpload} disabled={uploadingImage} style={{ display: 'none' }} />
        </label>

        <button
          onClick={handleSend}
          disabled={sending}
          style={{ background: '#C9A66B', color: '#18181B', border: 'none', padding: '10px 20px', borderRadius: 4, fontWeight: 'bold', cursor: 'pointer' }}
        >
          {sending ? 'Mengirim...' : 'Kirim Broadcast'}
        </button>

        {message && <p style={{ marginTop: 12 }}>{message}</p>}
      </div>

      <h3 style={{ color: '#C9A66B' }}>Riwayat Broadcast</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ borderBottom: '1px solid #48484E' }}>
            <th style={{ textAlign: 'left', padding: 8 }}>Subject</th>
            <th style={{ textAlign: 'left', padding: 8 }}>Segment</th>
            <th style={{ textAlign: 'left', padding: 8 }}>Status</th>
            <th style={{ textAlign: 'left', padding: 8 }}>Terkirim/Total</th>
            <th style={{ textAlign: 'left', padding: 8 }}>Tanggal</th>
          </tr>
        </thead>
        <tbody>
          {history.map((job) => (
            <tr key={job.id} style={{ borderBottom: '1px solid #2A2A2E' }}>
              <td style={{ padding: 8 }}>{job.subject}</td>
              <td style={{ padding: 8 }}>{job.segment}</td>
              <td style={{ padding: 8 }}>{job.status}</td>
              <td style={{ padding: 8 }}>{job.sent_count}/{job.total_recipients}</td>
              <td style={{ padding: 8 }}>{new Date(job.created_at).toLocaleString('id-ID')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
